<template>

     <template v-if="currentSchoolyear && adminSchoolyear">

        <el-card shadow="hover">
            <el-row align="middle">
                <el-col :span="12">
                    <div class="text-left">
                        <h3>{{ $t('classesList') }}</h3>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="text-right">
                        <el-button size="default" @click="addItem()">
                            {{ $t('add') }}
                        </el-button>
                    </div>
                </el-col>
            </el-row>

            <el-divider></el-divider>

            <el-table :data="pagedTableData" :empty-text="$t('noData')" style="width: 100%" border stripe v-loading="isLoading">

                <el-table-column type="index" :index="indexMethod" width="50" fixed> </el-table-column>
                <el-table-column sortable :label="$t('name')" prop="name" width="200" fixed> </el-table-column>
                <el-table-column sortable :label="$t('establishment')" prop="establishment" width="140" fixed>
                    <template #default="scope">
                        {{ getEstablishmentLocation(scope.row.establishment) }}
                    </template>
                </el-table-column>
                <el-table-column sortable :label="$t('code')" prop="code" width="140"> </el-table-column>
                <el-table-column sortable :label="$t('level')" prop="level" width="140">
                    <template #default="scope">
                        {{ getLevelName(scope.row.level) }}
                    </template>
                </el-table-column>
                <el-table-column sortable :label="$t('department')" prop="department" width="200">
                    <template #default="scope">
                        {{ getDepartmentName(scope.row.department) }}
                    </template>
                </el-table-column>
                <el-table-column sortable :label="$t('particularities')" prop="features" width="250">
                    <template #default="scope">
                        <el-tag v-for="(item, id) in getFeatures(scope.row.features)" :key="'tag_' + item" :type="id % 2 === 0 ? 'success' : ''" class="mb-3">
                            {{ item }}
                        </el-tag>
                    </template>
                </el-table-column>

                <el-table-column align="right" width="200" fixed="right">

                    <template #header>
                        <el-input v-model="search" size="small" :placeholder="$t('search')" />
                    </template>

                    <template #default="scope">
                        <el-button size="small" @click="editItem(scope.$index, scope.row)">
                            {{ $t('edit') }}
                        </el-button>
                        <el-button size="small" type="danger" @click="deleteItem(scope.$index, scope.row)">
                            {{ $t('delete') }}
                        </el-button>
                    </template>

                </el-table-column>

            </el-table>

            <div style="text-align: center; margin-top: 20px">

                <el-pagination
                    background
                    layout="prev, pager, next"
                    @current-change="setPage"
                    :hide-on-single-page="true"
                    :page-size="pageSize"
                    :total="total">
                </el-pagination>

            </div>
        </el-card>

        <el-dialog :title="$t('addClass')" v-model="addDialog" width="65%" top="8vh">

            <el-form
                :model="addClass"
                :rules="rules"
                :inline="true"
                :ref="addClassForm"
                label-width="140px"
                label-position="left"
                hide-required-asterisk>

                <el-form-item prop="name" :label="$t('name')">
                    <el-input
                        style="width: 250px"
                        :placeholder="$t('name')"
                        v-model="addClass.name"/>
                </el-form-item>

                <el-form-item prop="code" :label="$t('code')">
                    <el-input
                        style="width: 250px"
                        :placeholder="$t('code')"
                        v-model="addClass.code"/>
                </el-form-item>

                <el-form-item prop="establishment" :label="$t('establishment')">
                    <el-select
                        v-model="addClass.establishment"
                        :placeholder="$t('select')"
                        filterable
                        :no-data-text="$t('noData')"
                        :no-match-text="$t('noMatchingData')"
                        style="width: 250px">
                        <el-option
                            v-for="item in establishments"
                            :key="item.id"
                            :value="item.id"
                            :label="item.location">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item prop="level" :label="$t('level')">
                    <el-select
                        v-model="addClass.level"
                        :placeholder="$t('select')"
                        filterable
                        :no-data-text="$t('noData')"
                        :no-match-text="$t('noMatchingData')"
                        style="width: 250px">
                        <el-option
                            v-for="item in levels"
                            :key="item.id"
                            :value="item.id"
                            :label="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item prop="department" :label="$t('department')">
                    <el-select
                        clearable
                        filterable
                        v-model="addClass.department"
                        :placeholder="$t('select')"
                        :no-data-text="$t('noData')"
                        :no-match-text="$t('noMatchingData')"
                        style="width: 250px">
                        <el-option
                            v-for="item in departments"
                            :key="item.id"
                            :value="item.id"
                            :label="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item prop="features" :label="$t('particularities')">
                    <el-checkbox-group v-model="addClass.features" :max="2" size="small">
                        <el-checkbox-button :label="item.id" v-for="item in features" :key="item.id">
                            {{ item.label }}
                        </el-checkbox-button>
                    </el-checkbox-group>
                </el-form-item>

            </el-form>

            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="cancelForm(addClassForm)">{{ $t('cancel') }}</el-button>
                    <el-button type="primary" @click="submitForm(addClassForm)">{{ $t('confirm') }}</el-button>
                </span>
            </template>

        </el-dialog>

        <el-dialog :title="$t('editClass')" v-model="editDialog" width="65%" top="8vh">

            <el-form
                :model="editClass"
                :rules="rules"
                :inline="true"
                :ref="editClassForm"
                label-width="140px"
                label-position="left"
                hide-required-asterisk>

                <el-form-item prop="name" :label="$t('name')">
                    <el-input
                        style="width: 250px"
                        :placeholder="$t('name')"
                        v-model="editClass.name"/>
                </el-form-item>

                <el-form-item prop="code" :label="$t('code')">
                    <el-input
                        style="width: 250px"
                        :placeholder="$t('code')"
                        v-model="editClass.code"/>
                </el-form-item>

                <el-form-item prop="establishment" :label="$t('establishment')">
                    <el-select
                        v-model="editClass.establishment"
                        :placeholder="$t('select')"
                        filterable
                        :no-data-text="$t('noData')"
                        :no-match-text="$t('noMatchingData')"
                        style="width: 250px">
                        <el-option
                            v-for="item in establishments"
                            :key="item.id"
                            :value="item.id"
                            :label="item.location">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item prop="level" :label="$t('level')">
                    <el-select
                        v-model="editClass.level"
                        :placeholder="$t('select')"
                        filterable
                        :no-data-text="$t('noData')"
                        :no-match-text="$t('noMatchingData')"
                        style="width: 250px">
                        <el-option
                            v-for="item in levels"
                            :key="item.id"
                            :value="item.id"
                            :label="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item prop="department" :label="$t('department')">
                    <el-select
                        clearable
                        filterable
                        v-model="editClass.department"
                        :placeholder="$t('select')"
                        :no-data-text="$t('noData')"
                        :no-match-text="$t('noMatchingData')"
                        style="width: 250px">
                        <el-option
                            v-for="item in departments"
                            :key="item.id"
                            :value="item.id"
                            :label="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item prop="features" :label="$t('particularities')">
                    <el-checkbox-group v-model="editClass.features" :max="2" size="small">
                        <el-checkbox-button :label="item.id" v-for="item in features" :key="item.id">
                            {{ item.label }}
                        </el-checkbox-button>
                    </el-checkbox-group>
                </el-form-item>

            </el-form>

            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="cancelForm(editClassForm)">{{ $t('cancel') }}</el-button>
                    <el-button type="primary" @click="submitForm(editClassForm)">{{ $t('confirm') }}</el-button>
                </span>
            </template>

        </el-dialog>

     </template>

     <el-alert :title="$t('noCurrentSchoolyearWarning')" type="warning" v-else/>

</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import fr from 'element-plus/lib/locale/lang/fr'

import { Features } from '@/utils/enums'

import accessManager from '@/mixins/access-manager'

export default {
    name: 'Classes',
    mixins: [accessManager],
    data() {
      return {
        levels: [],
        features: [],
        departments: [],
        establishments: [],
        primaryColor: process.env.VUE_APP_PRIMARY_COLOR,
        editClass: {
            name: '',
            code: '',
            level: '',
            establishment: '',
            department: '',
            features: []
        },
        addClass: {
            name: '',
            code: '',
            level: '',
            establishment: '',
            department: '',
            features: []
        },
        rules: {
            name: [
                {
                    required: true,
                    message: this.$t('fieldRequired'),
                    trigger: 'blur',
                }
            ],
            code: [
                {
                    required: false,
                }
            ],
            level: [
                {
                    required: true,
                    message: this.$t('fieldRequired'),
                    trigger: 'blur',
                }
            ],
            establishment: [
                {
                    required: true,
                    message: this.$t('fieldRequired'),
                    trigger: 'blur',
                }
            ],
            department: [
                {
                    required: false,
                }
            ],
            features: [
                {
                    required: false,
                }
            ]
        },
        editClassForm: 'editClassForm',
        addClassForm: 'addClassForm',
        currentEditItem: null,
        editDialog: false,
        isLoading: false,
        addDialog: false,
        tableData: [],
        pageSize: 6,
        locale: fr,
        search: '',
        total: 0,
        page: 1
      }
    },
    created() {

      this.fetchClasses()

      var self = this

      this.$_.forIn(Features, function(value, key) {

          self.features.push(value)

      })

    },
    computed:{
      ...mapState({
        userData: state => state.session.userData
      }),
      ...mapGetters({
        getSettingValue: 'settings/getSettingValue'
      }),
      pagedTableData() {

        this.total = this.searching.length

        return this.searching.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page)

      },
      searching() {

        if (!this.search) {
            this.total = this.tableData.length
            return this.tableData
        }

        this.page = 1

        return this.tableData.filter(data => (
            data.name.toLowerCase().includes(this.search.toLowerCase()) ||
            data.code.toLowerCase().includes(this.search.toLowerCase())
        ))

      }
    },
    methods: {
      ...mapActions({
         fetchEstablishmentsDB: 'establishments/fetchEstablishmentsDB',
         fetchDepartmentsDB: 'departments/fetchDepartmentsDB',
         fetchClassesDB: 'classes/fetchClassesDB',
         fetchLevelsDB: 'levels/fetchLevelsDB',
      }),
      setPage (val) {

         this.page = val

      },
      indexMethod(index) {

         return index + ((this.page - 1) * this.pageSize) + 1

      },
      getLevelName(id){

          let level = this.levels.find(l => l.id == id)

          return level ? level.name : ''

      },
      getDepartmentName(id){

          let department = this.departments.find(d => d.id == id)

          return department ? department.name : ''

      },
      getEstablishmentLocation(id){

          let establishment = this.establishments.find(e => e.id == id)

          return establishment ? establishment.location : ''

      },
      getFeaturesLabel(str){

          let label = ''
          let parts = str.split(',')

          parts.forEach(part => {
            let feature = this.features.find(f => f.id == part)

            label += (label ? ' ' : '' ) + (feature ? feature.label : '')
          })

          return label

      },
      getFeatures(str){

          let tabs = []
          let parts = str.split(',')

          parts.forEach(part => {
            let feature = this.features.find(f => f.id == part)

            if (feature) tabs.push(feature.label)
          })

          return tabs

      },
      async fetchClasses(){

        if (!this.adminSchoolyear) return

        this.isLoading = true

        let resp1 = await this.fetchDepartmentsDB({
            action: 'getDepartments',
            params: {
                schoolyear: this.adminSchoolyear
            }
        })

        if (resp1.success && resp1.data) this.departments = resp1.data

        let resp4 = await this.fetchEstablishmentsDB({
            action: 'getEstablishments',
            params: {
                schoolyear: this.adminSchoolyear
            }
        })

        if (resp4.success && resp4.data) this.establishments = resp4.data

        let resp2 = await this.fetchLevelsDB({
            action: 'getLevels',
            params: {
                schoolyear: this.adminSchoolyear
            }
        })

        if (resp2.success && resp2.data) this.levels = resp2.data

        let resp3 = await this.fetchClassesDB({
            action: 'getClasses',
            params: {
                schoolyear: this.adminSchoolyear
            }
        })

        if (resp3.success){

            if (resp3.data) this.tableData = resp3.data

        }else{

            this.$message.error(this.$t('anErrorOccured'))

        }

        this.isLoading = false

      },
      addItem(){

           if (this.lockedData){
                this.$message.warning(this.$t('lockedData'))

                return
           }

           this.addDialog = true

      },
      async editItem(index, item){

            if (this.lockedData){
                this.$message.warning(this.$t('lockedData'))

                return
            }

            this.currentEditItem = item

            this.editClass.name = item.name
            this.editClass.code = item.code
            this.editClass.level = item.level == '0' ? '' : item.level
            this.editClass.department = item.department == '0' ? '' : item.department
            this.editClass.establishment = item.establishment == '0' ? '' : item.establishment

            this.editClass.features = []
            let list = item.features.split(",")
            list.forEach(e => {
                if (parseInt(e)) this.editClass.features.push(parseInt(e))
            })

            this.editDialog = true

      },
      deleteItem(index, item){

            if (this.lockedData){
                this.$message.warning(this.$t('lockedData'))

                return
            }

            this.$confirm(this.$t('deleteClassQuestion'), this.$t('delete'), {
                confirmButtonText: this.$t('yes'),
                cancelButtonText: this.$t('cancel'),
                type: 'warning',
            })
            .then(async () => {

                let task = await this.fetchClassesDB({
                    action: 'deleteClass',
                    params: {
                        id: item.id
                    }
                })

                if (task.success){

                    this.$message.success(this.$t('success'))
                    this.fetchClasses()

                }else{

                    this.$message.error(this.$t('anErrorOccured'))

                }

            })
            .catch(() => {

            })

      },
      submitForm(ref){

            this.$refs[ref].validate(async (valid) => {
                if (valid) {

                    if (ref === this.addClassForm){

                        let task = await this.fetchClassesDB({
                            action: 'addClass',
                            params: {
                                name: this.addClass.name,
                                code: this.addClass.code,
                                level: this.addClass.level,
                                establishment: this.addClass.establishment,
                                department: this.addClass.department,
                                features: this.addClass.features,
                                incumbent: '',
                                schoolyear: this.adminSchoolyear
                            }
                        })

                        if (task.success) this.$message.success(this.$t('success'))
                        else this.$message.error(this.$t('anErrorOccured'))

                    }else{

                        let newData = {}

                        if (this.currentEditItem.name !== this.editClass.name) {
                            newData['name'] = this.editClass.name
                        }

                        if (this.currentEditItem.code !== this.editClass.code) {
                            newData['code'] = this.editClass.code
                        }

                        if (this.currentEditItem.level !== this.editClass.level) {
                            newData['level'] = this.editClass.level
                        }

                        if (this.currentEditItem.establishment !== this.editClass.establishment) {
                            newData['establishment'] = this.editClass.establishment
                        }

                        if (this.currentEditItem.department !== this.editClass.department) {
                            newData['department'] = this.editClass.department || 0
                        }

                        if (this.currentEditItem.features !== this.editClass.features) {
                            newData['features'] = this.editClass.features
                        }

                        if (!this.$_.isEmpty(newData)){
                            let task = await this.fetchClassesDB({
                                action: 'editClass',
                                params: {
                                    id: this.currentEditItem.id,
                                    data: newData
                                }
                            })

                            if (task.success) this.$message.success(this.$t('success'))
                            else this.$message.error(this.$t('anErrorOccured'))
                        }

                    }

                    this.cancelForm(ref)
                    this.fetchClasses()

                } else {
                    return false
                }
            })

      },
      cancelForm(ref){

            this.$refs[ref].resetFields()

            if (ref === this.addClassForm) this.addDialog = false
            else this.editDialog = false

      }
    },
}
</script>